// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__List from "@rescript/core/src/Core__List.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utils.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "../ApiEndpoint.bs.js";

function buildQueryParams(params) {
  if (params !== 0) {
    return Core__List.reduce(Core__List.map(params, param => param[0] + `=` + param[1]), "", (acc, param) => {
      if (acc === "") {
        return `?` + param;
      } else {
        return acc + `&` + param;
      }
    });
  } else {
    return "";
  }
}

let CommonUtils = {
  buildQueryParams: buildQueryParams
};

function generateApiUrlV1(params, apiCallType) {
  let sdkAuthorization = params.sdkAuthorization;
  let forceSync = params.forceSync;
  let clientSecret = params.clientSecret;
  let clientSecretVal = Core__Option.getOr(clientSecret, "");
  let publishableKeyVal = Core__Option.getOr(params.publishableKey, "");
  let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecretVal, Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization));
  let pollIdVal = Core__Option.getOr(params.pollId, "");
  let payoutIdVal = Core__Option.getOr(params.payoutId, "");
  let authenticationIdVal = Core__Option.getOr(params.authenticationId, "");
  let merchantId = Core__Option.getOr(params.merchantId, "");
  let baseUrl = Core__Option.getOr(params.customBackendBaseUrl, ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKeyVal, undefined));
  let isRetrieveIntent;
  isRetrieveIntent = apiCallType === "RetrievePaymentIntent";
  let match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  let defaultParams = Core__List.filterMap({
    hd: match !== undefined || clientSecret === undefined ? undefined : [
        "client_secret",
        clientSecret
      ],
    tl: {
      hd: forceSync !== undefined && isRetrieveIntent ? [
          "force_sync",
          forceSync
        ] : undefined,
      tl: /* [] */0
    }
  }, x => x);
  let queryParams;
  switch (apiCallType) {
    case "RetrievePaymentIntent" :
    case "FetchSdkConfigs" :
    case "FetchClientList" :
      queryParams = defaultParams;
      break;
    default:
      queryParams = /* [] */0;
  }
  let path;
  switch (apiCallType) {
    case "FetchSessions" :
      path = "payments/session_tokens";
      break;
    case "FetchThreeDsAuth" :
      path = `payments/` + paymentIntentId + `/3ds/authentication`;
      break;
    case "CalculateTax" :
      path = `payments/` + paymentIntentId + `/calculate_tax`;
      break;
    case "CreatePaymentMethod" :
      path = "payment_methods";
      break;
    case "RetrievePaymentIntent" :
      path = `payments/` + paymentIntentId;
      break;
    case "CallAuthLink" :
      path = "payment_methods/auth/link";
      break;
    case "CallAuthExchange" :
      path = "payment_methods/auth/exchange";
      break;
    case "RetrieveStatus" :
      path = `poll/status/` + pollIdVal;
      break;
    case "ConfirmPayout" :
      path = `payouts/` + payoutIdVal + `/confirm`;
      break;
    case "FetchEnabledAuthnMethodsToken" :
      path = `authentication/` + authenticationIdVal + `/enabled_authn_methods_token`;
      break;
    case "FetchEligibilityCheck" :
      path = `authentication/` + authenticationIdVal + `/eligibility-check`;
      break;
    case "FetchAuthenticationSync" :
      path = `authentication/` + merchantId + `/` + authenticationIdVal + `/sync`;
      break;
    case "FetchPaymentMethodEligibility" :
      path = `payments/` + paymentIntentId + `/eligibility`;
      break;
    case "FetchSdkConfigs" :
      path = "v1/sdk/configs/web/sdk_config.json";
      break;
    case "FetchClientList" :
      path = `payments/` + paymentIntentId + `/client`;
      break;
  }
  return baseUrl + `/` + path + buildQueryParams(queryParams);
}

export {
  CommonUtils,
  generateApiUrlV1,
}
/* Utils-OrcaPaymentPage Not a pure module */
